import React from 'react';
import { Logo } from './header/Logo';
import { SummerCampPill } from './header/SummerCampPill';
import { DesktopMenu } from './header/DesktopMenu';
import { HeaderActions } from './header/HeaderActions';
import { MobileMenu } from './header/MobileMenu';
export function Header() {
  return <header className="sticky top-0 z-50 bg-paper border-b border-subtle-gray shadow-sm" data-id="element-288">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-289">
        <div className="flex justify-between items-center h-20" data-id="element-290">
          {/* Logo + Summer Camp (desktop) grouped on the left */}
          <div className="flex items-center gap-4 xl:gap-6" data-id="element-291">
            <Logo data-id="element-292" />
            <SummerCampPill data-id="element-293" />
          </div>

          <DesktopMenu data-id="element-294" />

          <HeaderActions data-id="element-295" />

          <MobileMenu data-id="element-296" />
        </div>
      </div>
    </header>;
}